import { GENDERS, LOCAL_STORAGE_USER_LOGIN_INFO } from "@app/constants/Common";
import * as CandidateService from '@app/services/CandidateService';
import { checkExistsCommonFieldValues } from "@app/utils/CandidateUtils";
import {
    stringToLowerCase
} from '@app/utils/CommonUtils';
import { showSuccessMessageSaveData } from "@pages/candidate/Common";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import React, { useEffect } from 'react';
import { toast } from "react-toastify";


const GenderCard = ({
    candidateId,
    isEditGender=false,
    // updateCandidatePersonal,
    initPersonal,
    onChange,
    allInputInfo,
    mode = 'Edit' // Default to Edit mode for backward compatibility
}) => {
    const [personal, setPersonal] = React.useState({});
    const [isEdit, setIsEdit] = React.useState(isEditGender);
    const [userLoginInfo, setUserLoginInfo] = React.useState({});

    useEffect(() => {
        if (initPersonal) {
            setPersonal(initPersonal);
        }
    }, [initPersonal]);
    useEffect(() => {
        setIsEdit(isEdit);
    }, [isEditGender]);

    const fetchPersonal = async (canId) => {
        CandidateService.getCandidatePersonalDetail(canId).then((res) => {
            setPersonal(res.content)
        })
    };

    useEffect(() => {
        if (candidateId) {
            fetchPersonal(candidateId)
        }
    }
    , [candidateId]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const onChangePersonalInfo = (event) => {
        if (mode !== 'Search' && event.target.name === 'gender') {
            if (event.target.value === 'nam') {
                personal.caller_name_to_email = 'anh';
            } else if (event.target.value === 'nữ') {
                personal.caller_name_to_email = 'chị';
            } else {
                personal.caller_name_to_email = '';
            }
        }
        personal[event.target.name] = event.target.value
        setPersonal({...personal})

        if (onChange) {
            onChange(personal);
        }
    }

    const updateCandidatePersonal = (fields, type) => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        // personal.allPersonalInfo = allPersonalInfo
        if (checkExistsCommonFieldValues(personal, userLoginInfo.id)) {
            return;
        }
        // setIsLoading(true)
        let payload = {...personal}
        // TODO: Will set user login name
        // if (!payload['vocative']) {
        //     payload['vocative'] = userLoginInfo.name
        // }
        // fields.forEach(field => {
        //     payload[field] = personal[field]
        //     // TODO: Will set user login name
        //     if (field === 'vocative' && !payload[field]) {
        //         payload[field] = DEFAULT_ADMIN_NAME
        //     }
        // })
        CandidateService.updateCandidatePersonalDetail({candidate_id: candidateId, personal: payload}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Giới tính</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEdit(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => {
                                        updateCandidatePersonal(['gender', 'caller_name_to_email', 'vocative'], 'update_gender');
                                    }}
                            >
                                Save
                            </button>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEdit(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label className={'w-100'}>Giới tính</label>
                    <select className='form-control'
                            name={'gender'}
                            disabled={!isEdit}
                            value={personal.gender ? personal.gender : ''}
                            onChange={event => onChangePersonalInfo(event)}>
                        <option value=''>&nbsp;</option>
                        {GENDERS.map(item => {
                            return <option value={item.toLowerCase()}
                                           key={`gender_${item}`}>{item}</option>
                        })}
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allPersonalInfo}
                                       field='gender'/>
                </div>
                {mode !== 'Search' && (
                    <>
                   
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Gọi UV là (email)</label>
                    <select className='form-control'
                            name={'caller_name_to_email'}
                            disabled={!isEdit}
                            value={personal.caller_name_to_email ? personal.caller_name_to_email : ''}
                            onChange={event => onChangePersonalInfo(event)}>
                        <option value=''>&nbsp;</option>
                        {personal.gender !== 'nữ' &&
                            <option value='anh'>anh</option>
                        }
                        {personal.gender !== 'nam' &&
                            <option value='chị'>chị</option>
                        }
                    </select>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>User xưng là (email)</label>
                    <select className='form-control'
                            name={'vocative'}
                            disabled={!isEdit}
                            value={personal.vocative ? personal.vocative : ""}
                            onChange={event => onChangePersonalInfo(event)}>

                        {personal.caller_name_to_email === 'anh' || personal.caller_name_to_email === 'chị' ?
                            <option value={stringToLowerCase(userLoginInfo.name)}>
                                {userLoginInfo.name}
                            </option>
                            :
                            <>
                                <option value=''>&nbsp;</option>
                                <option
                                    value={stringToLowerCase(userLoginInfo.name)}>{userLoginInfo.name}</option>
                                <option
                                    value={userLoginInfo.vocative}>{userLoginInfo.vocative}</option>
                            </>
                        }
                    </select>
                </div>
                </>
                )}
            </div>
        </div>
    );
};

export default GenderCard;


